var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 17.3643C2.87533 17.3643 2.48296 17.2011 2.15658 16.8748C1.83019 16.5484 1.66699 16.156 1.66699 15.6977V5.69767C1.66699 5.23934 1.83019 4.84698 2.15658 4.52059C2.48296 4.1942 2.87533 4.03101 3.33366 4.03101H16.667C17.1253 4.03101 17.5177 4.1942 17.8441 4.52059C18.1705 4.84698 18.3337 5.23934 18.3337 5.69767V15.6977C18.3337 16.156 18.1705 16.5484 17.8441 16.8748C17.5177 17.2011 17.1253 17.3643 16.667 17.3643H3.33366ZM10.0003 11.531L3.33366 7.36434V15.6977H16.667V7.36434L10.0003 11.531ZM10.0003 9.86434L16.667 5.69767H3.33366L10.0003 9.86434ZM3.33366 7.36434V5.69767V15.6977V7.36434Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.b03d0dd1e165b5ef25c8ddeed55ae598.svg";
export { ForwardRef as ReactComponent };